
import House from "../../../assets/outline/House.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HouseIcon({ className, dataTestid = "HouseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <House data-testid={dataTestid} className={classes} {...rest} />
  );
}
